module.exports = __webpack_public_path__ + "img/checkmark.596971fe.png";